import CoreAPI from "../coreAPI";
import LaunchDetails, { LaunchDetailsAPIResponse } from "../../classes/employerDashboard/launchDetails";

export default function APILaunchDetails(coreAPI: CoreAPI) {
  const api = {
    async removeParticipantDocument(fileName: string) {
      const response = await coreAPI.authCall<LaunchDetailsAPIResponse>({
        method: "DELETE",
        endpoint: `/launchDetails/participantFile/${fileName}`,
      });
      return LaunchDetails.fromAPI(response);
    },
    async uploadParticipantDocument(file: File) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("participantFileName", file.name);
      const response = await coreAPI.authCall<LaunchDetailsAPIResponse>({
        method: "POST",
        endpoint: `/launchDetails/participantFile/${file.name}`,
        body: formData,
      });
      return LaunchDetails.fromAPI(response);
    },
    async getLaunchDetails(): Promise<LaunchDetails | null> {
      try {
        const response = await coreAPI.authCall<LaunchDetailsAPIResponse>({
          endpoint: `/tenant/launchDetails`,
        });
        // remove creating email template text automatically without user click save
        return LaunchDetails.fromAPI(response);
      } catch (e: any) {
        return null;
      }
    },
    async createLaunchDetails(details: LaunchDetails) {
      const response = await coreAPI.authCall<LaunchDetailsAPIResponse>({
        method: "POST",
        endpoint: "/launchDetails",
        body: details.toJSONForAPI(),
      });
      return LaunchDetails.fromAPI(response);
    },
    async updateLaunchDetails(details: LaunchDetails) {
      if (details.launchDetailsId === -1) return api.createLaunchDetails(details);
      const response = await coreAPI.authCall<LaunchDetailsAPIResponse>({
        method: "PATCH",
        endpoint: `/launchDetails/${details.launchDetailsId}`,
        body: details.toJSONForAPI(),
      });
      return LaunchDetails.fromAPI(response);
    },
    async removeLaunchDetails(details: LaunchDetails) {
      await coreAPI.authCall<LaunchDetailsAPIResponse>({
        method: "DELETE",
        endpoint: `/launchDetails/${details.launchDetailsId}`,
      });
      return true;
    },
  };
  return api;
}
